import React, { useState } from "react";
import { searchSops, SearchResult, trackEvent } from "../services/api";

const PROCESS_AREAS = ["", "stow", "pick", "pack", "stage", "dispatch", "sort", "induct"];
const ROLES = ["", "associate", "pa", "manager"];

export function BrowsePage() {
  const [query, setQuery] = useState("");
  const [processArea, setProcessArea] = useState("");
  const [role, setRole] = useState("");
  const [stationId, setStationId] = useState("");
  const [results, setResults] = useState<SearchResult[]>([]);
  const [total, setTotal] = useState(0);
  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [adopted, setAdopted] = useState<Set<string>>(new Set());

  const handleSearch = async (e?: React.FormEvent) => {
    e?.preventDefault();
    setLoading(true);
    try {
      const data = await searchSops({ q: query, process_area: processArea, role, station_id: stationId });
      setResults(data.results);
      setTotal(data.total);
      setSearched(true);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const handleAdopt = async (r: SearchResult) => {
    const key = r.sop_id;
    const isAdopted = adopted.has(key);
    await trackEvent({
      sop_id: r.sop_id,
      station_id: r.station_id,
      event_type: isAdopted ? "unadopt" : "adopt",
      actor_station: stationId || "unknown",
      source_station: r.station_id,
    });
    setAdopted((prev) => {
      const next = new Set(prev);
      isAdopted ? next.delete(key) : next.add(key);
      return next;
    });
  };

  return (
    <div style={{ maxWidth: 720, margin: "0 auto", padding: 24 }}>
      <h2>Browse SOPs</h2>

      <form onSubmit={handleSearch} style={{ marginBottom: 24 }}>
        <input value={query} onChange={(e) => setQuery(e.target.value)}
          placeholder="Search SOPs... (e.g. 'stow heavy packages')"
          style={{ width: "100%", padding: 10, fontSize: 16, marginBottom: 12 }} />

        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
          <select value={processArea} onChange={(e) => setProcessArea(e.target.value)} style={{ padding: 8, flex: 1 }}>
            <option value="">All Process Areas</option>
            {PROCESS_AREAS.filter(Boolean).map((a) => <option key={a} value={a}>{a}</option>)}
          </select>
          <select value={role} onChange={(e) => setRole(e.target.value)} style={{ padding: 8, flex: 1 }}>
            <option value="">All Roles</option>
            {ROLES.filter(Boolean).map((r) => <option key={r} value={r}>{r}</option>)}
          </select>
          <input value={stationId} onChange={(e) => setStationId(e.target.value)}
            placeholder="Station ID" style={{ padding: 8, flex: 1 }} />
        </div>

        <button type="submit" disabled={loading}
          style={{ padding: "10px 24px", background: "#1976d2", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontSize: 15 }}>
          {loading ? "Searching..." : "Search"}
        </button>
      </form>

      {searched && (
        <p style={{ color: "#666", marginBottom: 16 }}>{total} result{total !== 1 ? "s" : ""} found</p>
      )}

      {results.map((r) => (
        <div key={`${r.sop_id}_${r.station_id}`}
          style={{ border: "1px solid #ddd", borderRadius: 8, padding: 16, marginBottom: 12 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div>
              <h3 style={{ margin: 0 }}>{r.title}</h3>
              <p style={{ color: "#666", margin: "4px 0 8px" }}>
                {r.process_area} · {r.target_role} · Station: {r.station_id}
              </p>
            </div>
            <span style={{ fontSize: 12, color: "#999", whiteSpace: "nowrap" }}>
              relevance: {(r.score ?? 0).toFixed(1)}
            </span>
          </div>
          {r.purpose && <p style={{ margin: "0 0 8px" }}>{r.purpose}</p>}
          {r.quick_reference && (
            <div style={{ background: "#f5f5f5", padding: 10, borderRadius: 6, fontSize: 13 }}>
              <strong>Quick Reference</strong>
              <pre style={{ whiteSpace: "pre-wrap", margin: "6px 0 0" }}>{r.quick_reference}</pre>
            </div>
          )}
          <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
            <button onClick={() => handleAdopt(r)}
              style={{
                padding: "6px 14px", border: "1px solid #4caf50", borderRadius: 6, cursor: "pointer",
                background: adopted.has(r.sop_id) ? "#4caf50" : "#fff",
                color: adopted.has(r.sop_id) ? "#fff" : "#4caf50", fontSize: 13,
              }}>
              {adopted.has(r.sop_id) ? "✅ Adopted" : "Adopt for my station"}
            </button>
          </div>
        </div>
      ))}

      {searched && results.length === 0 && (
        <p style={{ color: "#999", textAlign: "center", marginTop: 40 }}>
          No approved SOPs match your search. Try broader terms or different filters.
        </p>
      )}
    </div>
  );
}
